import { Button, Group, Modal, Select, Stack } from '@mantine/core';
import useSWR from 'swr';
import { type Service, type Services } from '@/schemas/API/GET/service/response';
import { getFetcher, postFetcher } from '@/api/fetchers';
import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { displayError } from '@/utils/error/errorHandler';
import { useNavigate } from 'react-router-dom';

interface PlanNotFoundProps {
  clientId: string
}


export const PlanNotFound = (props : PlanNotFoundProps) : JSX.Element => {

  const [openedCreatePlanModal, { open: openCreatePlanModal, close: closeCreatePlanModal }] = useDisclosure(false);
  const { data: availableServices } = useSWR<Services>('services', getFetcher);
  const navigate = useNavigate();

  const [service, setService] = useState<Service | null>(availableServices ? availableServices[0] : null);

  function findServiceWithId(id: string): Service | null {
    return availableServices?.find((s) => s.id === parseInt(id)) ?? null;
  }

  useEffect(() => {
    if (service ?? !availableServices) return;
    setService(availableServices[0])
  }, [availableServices]);

  const createPlan = async () : Promise<void> => {
    if (!service) return;
    try {
      const id = service.id;
      const carePlanData = {
        serviceId: id,
        applicantId: null,
        healthDesc: "",
        note: undefined,
        lastRevDate: dayjs().format('YYYY-MM-DD'),
        nextRevDate: dayjs().add(1, 'year').format('YYYY-MM-DD'),
        expDate: dayjs().add(1, 'year').format('YYYY-MM-DD'),
      };

      await postFetcher(`/clients/${props.clientId}/careplans`, carePlanData);
      navigate(`/clients/${props.clientId}/personal`);
    } catch (error) {
      displayError(error);
    }
  }

  return (
    <Stack
      h={300}
      bg="var(--mantine-color-body)"
      align="stretch"
      justify="center"
      gap="xl"
      className="border rounded h-full w-full justify-center items-center"
    >
      <div>
        Nenalezen žádný plán péče.
      </div>
      <Button
        onClick={openCreatePlanModal}
      >
        Vytvořit nový
      </Button>
      <Modal
        title="Vytvoření plánu"
        opened={openedCreatePlanModal}
        onClose={closeCreatePlanModal}
        centered
        className="justify-center items-center"

      >
        <Select
          label="Služba"
          onChange={e => {
            setService(findServiceWithId(e ?? '0'));
          }}
          data={availableServices?.map(service => ({
            value: service.id.toString(),
            label: service.name,
          }))}
          defaultValue={service?.id.toString()}
          allowDeselect={false}
          className="mb-10 justify-center"
        />
        <Group justify="center">
          <Button
            onClick={() => {
              closeCreatePlanModal();
              createPlan();
            }}
            size="md"
          >
            Vytvořit nový plán
          </Button>
        </Group>
      </Modal>
    </Stack>
  )
}